// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cae7f6fd","239":"9ff89a71","453":"918d394a","455":"fd6f5473"}[chunkId] + ".chunk.js";
};